/* BYON · Guías del blog que venden (ronda 11, 25-sep-2026 · Bloque D2 · SEO-3 A)
 * Solo se carga con el interruptor guias_atc encendido (sections/main-article.liquid).
 * - Barra fija inferior del celular (< 750 px): aparece después del 35% del scroll y se oculta junto al footer.
 *   Mientras se ve, <body> lleva byon-sticky-atc-visible (contrato vigente: WhatsApp sube a 88 px). Con una capa
 *   abierta (byon-overlay-open, K7) la oculta el CSS.
 * - Medición K1: byonTrack('guide_cta_click', {guide, collection, placement}) en la caja, la barra fija, el final y la
 *   barra lateral. El agregado al carro lo mide assets/quick-add.js (atc_source 'guide').
 */
(function () {
  if (window.__byonArticleShop) return;
  window.__byonArticleShop = true;
  var doc = document;
  var win = window;

  function track(name, data) {
    (win.byonTrack || function () {})(name, data);
  }

  doc.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var cta = target.closest('[data-byon-guide-cta]');
    if (!cta) return;
    var host = cta.closest('[data-byon-guide]');
    track('guide_cta_click', {
      guide: host ? host.getAttribute('data-byon-guide') || '' : '',
      collection: cta.getAttribute('data-byon-collection') || '',
      placement: cta.getAttribute('data-byon-guide-cta') || '',
    });
  });

  function init() {
    var bar = doc.querySelector('[data-byon-art-sticky]');
    if (!bar) return;
    var link = bar.querySelector('a');
    var mq = win.matchMedia('(max-width: 749px)');
    var footer = doc.querySelector('footer') || doc.querySelector('.shopify-section-group-footer-group');
    var shown = false;
    var ticking = false;

    function update() {
      ticking = false;
      var root = doc.documentElement;
      var max = Math.max(1, root.scrollHeight - win.innerHeight);
      var progress = (win.pageYOffset || root.scrollTop || 0) / max;
      var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      var show = mq.matches && progress >= 0.35 && footerTop > win.innerHeight;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.setAttribute('tabindex', show ? '0' : '-1');
      doc.body.classList.toggle('byon-sticky-atc-visible', show);
    }

    function request() {
      if (ticking) return;
      ticking = true;
      win.requestAnimationFrame(update);
    }

    win.addEventListener('scroll', request, { passive: true });
    win.addEventListener('resize', request);
    if (mq.addEventListener) mq.addEventListener('change', request);
    else if (mq.addListener) mq.addListener(request);
    update();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
